import { useTw } from '../../../utils/Styles'
import { XIcon } from '@heroicons/react/outline'

type Props = {
  onClick: () => void
  className: string
}

export function CloseButton({ onClick, className }: Props) {
  const tw = useTw()

  return (
    <button onClick={() => onClick && onClick()} className={className}>
      <XIcon className={tw`h-7 w-7 text-background-text`} />
    </button>
  )
}
